/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  UpsertSubscriptionItemEntity,
  UpsertSubscriptionItemEntity$inboundSchema,
  UpsertSubscriptionItemEntity$Outbound,
  UpsertSubscriptionItemEntity$outboundSchema,
} from "./upsertsubscriptionitementity.js";

/**
 * The update behavior for the subscription (defaults to proration)
 */
export const UpdateBehavior = {
  ProrationChargeImmediately: "proration-charge-immediately",
  ProrationCharge: "proration-charge",
  ProrationNone: "proration-none",
} as const;
/**
 * The update behavior for the subscription (defaults to proration)
 */
export type UpdateBehavior = ClosedEnum<typeof UpdateBehavior>;

export type UpdateSubscriptionRequestEntity = {
  /**
   * List of subscription items to update/create. If no item ID is provided, the item will be created.
   */
  items?: Array<UpsertSubscriptionItemEntity> | undefined;
  /**
   * The update behavior for the subscription (defaults to proration)
   */
  updateBehavior?: UpdateBehavior | undefined;
};

/** @internal */
export const UpdateBehavior$inboundSchema: z.ZodNativeEnum<
  typeof UpdateBehavior
> = z.nativeEnum(UpdateBehavior);
/** @internal */
export const UpdateBehavior$outboundSchema: z.ZodNativeEnum<
  typeof UpdateBehavior
> = UpdateBehavior$inboundSchema;

/** @internal */
export const UpdateSubscriptionRequestEntity$inboundSchema: z.ZodType<
  UpdateSubscriptionRequestEntity,
  z.ZodTypeDef,
  unknown
> = z.object({
  items: z.array(UpsertSubscriptionItemEntity$inboundSchema).optional(),
  update_behavior: UpdateBehavior$inboundSchema.default("proration-charge"),
}).transform((v) => {
  return remap$(v, {
    "update_behavior": "updateBehavior",
  });
});
/** @internal */
export type UpdateSubscriptionRequestEntity$Outbound = {
  items?: Array<UpsertSubscriptionItemEntity$Outbound> | undefined;
  update_behavior: string;
};

/** @internal */
export const UpdateSubscriptionRequestEntity$outboundSchema: z.ZodType<
  UpdateSubscriptionRequestEntity$Outbound,
  z.ZodTypeDef,
  UpdateSubscriptionRequestEntity
> = z.object({
  items: z.array(UpsertSubscriptionItemEntity$outboundSchema).optional(),
  updateBehavior: UpdateBehavior$outboundSchema.default("proration-charge"),
}).transform((v) => {
  return remap$(v, {
    updateBehavior: "update_behavior",
  });
});

export function updateSubscriptionRequestEntityToJSON(
  updateSubscriptionRequestEntity: UpdateSubscriptionRequestEntity,
): string {
  return JSON.stringify(
    UpdateSubscriptionRequestEntity$outboundSchema.parse(
      updateSubscriptionRequestEntity,
    ),
  );
}
export function updateSubscriptionRequestEntityFromJSON(
  jsonString: string,
): SafeParseResult<UpdateSubscriptionRequestEntity, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateSubscriptionRequestEntity$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateSubscriptionRequestEntity' from JSON`,
  );
}
